import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getSessionToken } from '../services/authService';

const AppSettingsContext = createContext({
  easyhelpLeaderboardEnabled: true,
  umamiEnabled: true,
  developerOptionsEnabled: false,
  reload: () => {}
});

export function AppSettingsProvider({ children }) {
  const [easyhelpLeaderboardEnabled, setEasyhelpLeaderboardEnabled] = useState(true);
  const [umamiEnabled, setUmamiEnabled] = useState(true);
  const [developerOptionsEnabled, setDeveloperOptionsEnabled] = useState(false);

  const reload = useCallback(async () => {
    try {
      const headers = {};
      const token = await getSessionToken();
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const res = await fetch('/api/app-settings', { headers });
      if (res.ok) {
        const data = await res.json();
        setEasyhelpLeaderboardEnabled(Boolean(data.easyhelp_leaderboard_enabled ?? true));
        setUmamiEnabled(Boolean(data.umami_enabled));
        setDeveloperOptionsEnabled(Boolean(data.developer_options_enabled));
      }
    } catch {
      // Netzwerkfehler – Standardwert beibehalten
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    const handleAuthChange = () => {
      reload();
    };

    window.addEventListener('auth-changed', handleAuthChange);
    return () => window.removeEventListener('auth-changed', handleAuthChange);
  }, [reload]);

  return (
    <AppSettingsContext.Provider value={{ easyhelpLeaderboardEnabled, umamiEnabled, developerOptionsEnabled, reload }}>
      {children}
    </AppSettingsContext.Provider>
  );
}

export function useAppSettings() {
  return useContext(AppSettingsContext);
}
